import jwt_decode from "jwt-decode";

export const GetToken = function () {
    return localStorage.getItem('token');
}

export const DecodedToken = function () {
    const token = localStorage.getItem('token');
    if (token) {
        try {
            return jwt_decode(token);
        } catch (error) {
            console.error("Error decoding token:", error);
            return null;
        }
    } else {
        return null;
    }
}

export const SetToken = function(value) {
    localStorage.setItem('token', value);
}

export const ClearToken = function() {
    localStorage.removeItem('token');
}

export const UserLoggedIn = function() {
    try {
        const decodedToken = DecodedToken();
        if (!decodedToken) {
            return false;
        }
        const timestamp = new Date().getTime() / 1000;
        return decodedToken.exp > timestamp;
    } catch (error) {
        console.error("Error checking login status:", error);
        return false;
    }
}

// Adding helper functions to work with permissions
export const GetUserPermissions = function() {
    const token = DecodedToken();
    if (token && token.permissions) {
        return token.permissions;
    }
    return [];
}

export const HasPermission = function(requiredPermission) {
    const permissions = GetUserPermissions();
    return permissions.includes(requiredPermission) || permissions.includes('all');
}
